import { CompanyDetailsFormBaseDataProvider } from './CompanyDetailsFormBaseDataProvider';
import { sanitizeArray } from '../../../../utils/sanitization.utils';
import { CountryData } from '../../../types/country-data';
import _ from 'lodash';
import { StateData } from '../../../types/state-data';
import { IndustryData } from '../../../types/industry-data';
import { CompanyRoleData } from '../../../types/company-role-data';
import { htmlEncode } from '../../../../utils/escape.utils';
import { CompanyTypeData } from '../../../types/company-type-data';
import { CompanyCustomizationData } from '../../../types/company-customization-data';
import { User } from '../../../types/user';
import { TimezoneData } from '../../../types/timezone-data';
import { LanguageData } from '../../../types/language-data';

export class CompanyDetailsFormGzDataProvider extends CompanyDetailsFormBaseDataProvider {
  public async getCountries(): Promise<CountryData[]> {
    const record = await this.dependencies.api.clients.Countries.GetCountries().toPromise();

    if (!record || !record.data) {
      throw new Error('No countries data');
    }

    const countries = sanitizeArray(record.data);

    return _.orderBy(countries, [(country: CountryData) => country.countryName.toLowerCase()], ['asc']);
  }

  public async getStates(): Promise<StateData[]> {
    const record = await this.dependencies.api.clients.Countries.GetStates().toPromise();

    if (!record || !record.data) {
      throw new Error('No states data');
    }

    const states = sanitizeArray(record.data);

    return _.orderBy(states, [(state: StateData) => state.stateName.toLowerCase()], ['asc']);
  }

  public async getIndustries(): Promise<IndustryData[]> {
    const data = await this.dependencies.api.clients.Company.GetIndustries().toPromise();
    return data;
  }

  public async getCompanyRoles(): Promise<CompanyRoleData[]> {
    const data = await this.dependencies.api.clients.Company.GetCompanyRoles().toPromise();
    return sanitizeArray(data);
  }

  public async getDefaultLogoId(): Promise<string> {
    const logoId = await this.dependencies.api.clients.Company.GetDefaultLogoId().toPromise();
    return htmlEncode(logoId);
  }

  public async getCompanyTypes(): Promise<CompanyTypeData[]> {
    const data = await this.dependencies.api.clients.Company.GetCompanyTypes().toPromise();
    return sanitizeArray(data);
  }

  public async getCompanyCustomizations(): Promise<CompanyCustomizationData[]> {
    const data = await this.dependencies.api.clients.Company.GetCompanyCustomizations().toPromise();
    return sanitizeArray(data);
  }

  public async getTimezones(): Promise<TimezoneData[]> {
    const data = await this.dependencies.api.clients.Timezones.GetTimezones().toPromise();
    return sanitizeArray(data);
  }

  public async getLanguages(): Promise<LanguageData[]> {
    const data = await this.dependencies.api.clients.Languages.GetLanguages().toPromise();
    return sanitizeArray(data);
  }

  public async getLoggedUser(): Promise<User> {
    const user = await this.dependencies.api.clients.Users.GetLoggedUser().toPromise();

    if (!user) {
      throw new Error('No logged user data');
    }

    return user;
  }

  public async getRootVisibilityTree(): Promise<string> {
    const rootVisibilityTree = await this.dependencies.api.clients.Company.GetRootVisibilityTree().toPromise();
    return htmlEncode(rootVisibilityTree);
  }
}
